/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { strings } from "../../../common/Strings/Strings";
import LoaderInline from "../../../components/LoaderInline";
import Button from "../../../components/Button";
import { Cross } from "../../../common/Icons/Cross";
import { PlusIcon } from "../../../common/Icons/PlusIcon";
import { CheckCircle } from "../../../common/Icons/CheckCircle";
import { ExclamationMark } from "../../../common/Icons/ExclamationMark";

interface FileUpload {
  file: File;
  state: UploadSate;
  error?: string | null;
}

type UploadSate = "success" | "error" | "pending" | "loading" | "too_large";

interface Props {
  deletePendingFile(item: FileUpload): void;
  loading: boolean;
  newFiles: FileUpload[];
  onChoose(): void;
}

const UploadFiles: React.FC<Props> = ({ deletePendingFile, loading, newFiles, onChoose }: Props) => {
  const getIcon = (state: UploadSate) => {
    if (state === "success" || state === "pending") {
      return <CheckCircle className="text-green-500" />;
    }
    if (state === "error" || state === "too_large") {
      return <ExclamationMark className="text-red-500" />;
    }
    if (state === "loading") {
      return <LoaderInline />;
    }
    return <></>;
  };

  return (
    <div className="tw-card px-4 divide-y dark:divide-gray-700">
      {newFiles.map((file, index) => (
        <>
          <div className="flex items-center py-4" key={`new-${index}`}>
            <div className="mr-3">{getIcon(file.state)}</div>
            <div className="grow">
              <div className="break-all">{file.file.name}</div>
              <div hidden={!file.error} className="text-sm text-red-700 dark:text-red-400">
                {file.error}
              </div>
            </div>
            <Button className="ml-3" onClick={() => deletePendingFile(file)} variant="icon">
              <Cross />
            </Button>
          </div>
        </>
      ))}
      <div className="py-4">
        <Button disabled={loading} onClick={onChoose} variant="link">
          <PlusIcon className="mr-2" />
          {strings.addFiles}
        </Button>
      </div>
    </div>
  );
};

export default UploadFiles;
